import { render, staticRenderFns } from "./configureReviewers.vue?vue&type=template&id=49b9a7aa&lang=html&"
import script from "./configureReviewers.vue?vue&type=script&lang=ts&"
export * from "./configureReviewers.vue?vue&type=script&lang=ts&"
import style0 from "./configureReviewers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports